// extracted by mini-css-extract-plugin
module.exports = {"header":"PlainHeader_header__7PR2_"};